<script setup lang="ts">
  import { ref } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: String,
    posts: Array,
    headerType: String,
    link: String,
  });


  const parameters = ref({
    navigation: true,
    breakpoints: {
      1: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
</script>
<template>
  <SfSection :title="header" :headerType :link="link || $route('web.blog.post.index')">
    <SfArticlesCarousel :posts :parameters />
  </SfSection>
</template>
